const closeAside = () => {
    document.querySelector('.aside-menu.show').classList.remove('show')
}
const showAside = (aside) => {
    aside.classList.add('show')
}

export const initAsideMenu = (aside, asideToggle) => {
    asideToggle.addEventListener('click', () => showAside(aside))
    aside.querySelector('.overlay').addEventListener('click', closeAside)
    aside.querySelector('.aside-close').addEventListener('click', closeAside)
    aside.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeAside)
    })
    aside.querySelectorAll('button').forEach((link) => {
        link.addEventListener('click', closeAside)
    })
}
